/**
 * Echo Madness — Hidden Mechanic
 *
 * Each echo destruction frays the Echo Knight's connection to alternate timelines.
 * Progressive debuffs accrue at thresholds. The player sees a vague "Echo Disturbance"
 * label but doesn't know the internal tier names or full mechanical consequences.
 */
// =============================================================================
// TIER DEFINITIONS
// =============================================================================
const NO_EFFECTS = {
    attackModifier: 0,
    damageModifier: 0,
    initiativeModifier: 0,
    saveModifier: 0,
    concentrationDisadvantage: false,
    deathSaveDisadvantage: false,
};
export const ECHO_MADNESS_TIERS = [
    {
        name: 'Whispers',
        playerLabel: 'Faint echoes',
        minScore: 1,
        color: '#7dd3fc', // dim cyan
        effects: { ...NO_EFFECTS },
    },
    {
        name: 'Unease',
        playerLabel: 'Growing unease',
        minScore: 3,
        color: '#a3d9a5', // pale green-cyan
        effects: {
            attackModifier: 0,
            damageModifier: -1,
            initiativeModifier: -1,
            saveModifier: 0,
            concentrationDisadvantage: false,
            deathSaveDisadvantage: false,
        },
    },
    {
        name: 'Fracture',
        playerLabel: 'Fractured focus',
        minScore: 5,
        color: '#fbbf24', // amber
        effects: {
            attackModifier: -1,
            damageModifier: -2,
            initiativeModifier: -1,
            saveModifier: 0,
            concentrationDisadvantage: true,
            deathSaveDisadvantage: false,
        },
    },
    {
        name: 'Blur',
        playerLabel: 'Reality blurs',
        minScore: 7,
        color: '#f97316', // orange
        effects: {
            attackModifier: -2,
            damageModifier: -3,
            initiativeModifier: -2,
            saveModifier: -1,
            concentrationDisadvantage: true,
            deathSaveDisadvantage: false,
        },
    },
    {
        name: 'Sickness',
        playerLabel: 'Echo sickness',
        minScore: 9,
        color: '#ef4444', // red
        effects: {
            attackModifier: -3,
            damageModifier: -4,
            initiativeModifier: -2,
            saveModifier: -1,
            concentrationDisadvantage: true,
            deathSaveDisadvantage: true,
        },
    },
    {
        name: 'Shattered',
        playerLabel: 'Shattered self',
        minScore: 11,
        color: '#dc2626', // crimson
        effects: {
            attackModifier: -4,
            damageModifier: -5,
            initiativeModifier: -3,
            saveModifier: -2,
            concentrationDisadvantage: true,
            deathSaveDisadvantage: true,
        },
    },
];
// =============================================================================
// HELPERS
// =============================================================================
/**
 * Get the current echo madness tier and its effects for a given score.
 * Returns null if score is 0 (no disturbance).
 */
export function getEchoMadnessTier(score) {
    if (score <= 0)
        return null;
    // Walk tiers in reverse to find the highest matching threshold
    for (let i = ECHO_MADNESS_TIERS.length - 1; i >= 0; i--) {
        if (score >= ECHO_MADNESS_TIERS[i].minScore) {
            return ECHO_MADNESS_TIERS[i];
        }
    }
    return ECHO_MADNESS_TIERS[0]; // fallback (shouldn't happen if score >= 1)
}
//# sourceMappingURL=echo-madness.js.map